import axios from "axios";
import { FavoriteCorpListModel, FavoriteCorpSearchOptions } from "models";
import { IAPIResult } from "models/interfaces";

export async function search(options: FavoriteCorpSearchOptions, withClone?:boolean) {
  // await Utils.sleep(300);
  const response = await axios.post<IAPIResult<FavoriteCorpListModel>>(
    "/api.d/v1/ec/favorite-corp/search",
    options
  );

  if (withClone && options.get_count) {
    while (response.data.data.favorite_corp_list.length < options.get_count) {
      response.data.data.favorite_corp_list.push({
        corp_id: "",
        favorite_corp_id: "",
        logo_image: {
          file_name: "",
          file_data: "",
          image_url: "",
        },
        corp_name: "",
      });
    }
  }

  return response.data;
}

export async function add(options: { favorite_corp_id: string }) {
  // await Utils.sleep(300);
  const response = await axios.post<IAPIResult>(
    "/api.d/v1/ec/favorite-corp/create",
    options
  );
  return response.data;
}

export async function del(favorite_corp_id: string) {
  // await Utils.sleep(300);

  const data = { favorite_corp_id };

  const response = await axios.delete<IAPIResult>(
    "/api.d/v1/ec/favorite-corp/delete",
    { data }
  );
  return response.data;
}
